import React from "react";
import { Pagination } from "react-bootstrap";

/**
 * Page numbers shortened with ellipses, e.g. ‹ 1 … 4 5 [6] 7 8 … 42 ›.
 * `currentPage` is 0-based, like the backend's page parameter.
 */
const PaginationBar = ({ currentPage, totalPages, onPageChange, siblings = 2 }) => {
    if (totalPages <= 1) return null;

    const first = 0;
    const last = totalPages - 1;
    const start = Math.max(first + 1, currentPage - siblings);
    const end = Math.min(last - 1, currentPage + siblings);

    const items = [first];
    if (start > first + 1) items.push("start-ellipsis");
    for (let page = start; page <= end; page++) items.push(page);
    if (end < last - 1) items.push("end-ellipsis");
    if (last > first) items.push(last);

    return (
        <Pagination className="justify-content-center flex-wrap">
            <Pagination.Prev
                disabled={currentPage === first}
                onClick={() => onPageChange(currentPage - 1)}
            />
            {items.map((item) =>
                typeof item === "number" ? (
                    <Pagination.Item
                        key={item}
                        active={item === currentPage}
                        onClick={() => onPageChange(item)}
                    >
                        {item + 1}
                    </Pagination.Item>
                ) : (
                    <Pagination.Ellipsis key={item} disabled />
                )
            )}
            <Pagination.Next
                disabled={currentPage === last}
                onClick={() => onPageChange(currentPage + 1)}
            />
        </Pagination>
    );
};

export default PaginationBar;
